module.exports = __webpack_public_path__ + "static/media/m3psilver.0ba564d0.png";